
import { defineComponent, ref, watch } from 'vue'
import { User } from '@/retail/contexts/customers/services/user.service'
import EditInfoModal from './EditInfoModal.vue'

export default defineComponent({
  name: 'CustomerInfo',
  components: { EditInfoModal },
  props: {
    customerInfo: {
      type: Object as () => User,
      require: true,
    },
    isUpdateModalVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const local_isUpdateModalVisible = ref(props.isUpdateModalVisible)
    const toggleUpdateModalVisible = () => {
      emit('toggle-update-modal-visible')
    }

    const updateCustomerInfo = (customerInfo: User) => {
      emit('update-customer-info', customerInfo)
    }

    watch(
      () => props.isUpdateModalVisible,
      (newValue) => {
        local_isUpdateModalVisible.value = newValue
      },
    )

    return {
      local_isUpdateModalVisible,
      toggleUpdateModalVisible,
      updateCustomerInfo,
    }
  },
})
